(() => {
  'use strict';
  if (window.wsKlaviyoSignupLoaded) return;
  window.wsKlaviyoSignupLoaded = true;
  const selector = 'form[data-ws-klaviyo-signup]';
  const initialize = () => {
    document.querySelectorAll(selector).forEach((form) => {
      const button = form.querySelector('button[type="submit"]');
      if (button && !form.dataset.busy && !form.dataset.accepted) button.disabled = false;
    });
  };
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches(selector)) return;
    event.preventDefault();
    if (form.dataset.busy || form.dataset.accepted) return;
    const email = form.querySelector('input[type="email"]');
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[role="status"]');
    const offer = form.querySelector('[data-signup-offer]');
    email.value = email.value.trim();
    if (!form.reportValidity()) return;
    if (form.elements.website?.value) {
      status.textContent = 'We could not process this request. Please refresh the page and try again.';
      status.dataset.state = 'error';
      return;
    }
    const originalLabel = button.textContent;
    form.dataset.busy = 'true';
    form.setAttribute('aria-busy', 'true');
    email.readOnly = true;
    button.disabled = true;
    button.textContent = 'Submitting…';
    status.textContent = '';
    delete status.dataset.state;
    if (offer) offer.hidden = true;
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(form.dataset.siteId)}`,
        {
          method: 'POST',
          credentials: 'omit',
          mode: 'cors',
          headers: {
            accept: 'application/vnd.api+json',
            'content-type': 'application/vnd.api+json',
            revision: '2026-07-15'
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: form.dataset.signupSource,
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email.value,
                      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                    }
                  }
                }
              },
              relationships: { list: { data: { type: 'list', id: form.dataset.listId } } }
            }
          }),
          signal: controller.signal
        }
      );
      if (response.status !== 202) {
        const failure = new Error('Subscription request was not accepted');
        failure.status = response.status;
        throw failure;
      }
      form.dataset.accepted = 'true';
      email.readOnly = true;
      button.textContent = 'Request received';
      status.dataset.state = 'accepted';
      status.textContent = 'Request received. Check your inbox and spam folder for a confirmation email if prompted. Confirming completes your signup.';
      if (offer) offer.hidden = false;
      status.focus({ preventScroll: true });
    } catch (error) {
      email.readOnly = false;
      status.dataset.state = 'error';
      status.textContent = error.status === 429
        ? 'Too many attempts. Please wait a few minutes and try again.'
        : error.name === 'AbortError'
          ? 'We could not confirm your request. Check your inbox before trying again.'
          : 'We could not complete your signup. Please try again or email support@wellnessshine.com for help.';
      button.disabled = false;
      button.textContent = originalLabel;
      status.focus({ preventScroll: true });
    } finally {
      window.clearTimeout(timeout);
      delete form.dataset.busy;
      form.removeAttribute('aria-busy');
    }
  });
  initialize();
  document.addEventListener('DOMContentLoaded', initialize);
  document.addEventListener('shopify:section:load', initialize);
})();
